import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSetNotification } from '../../../context/Notification';
import envVars from '../../../constants/envVars';
import useRequest from '../../../hooks/useRequest';
import { CallDispositionPayload } from '../types';
import { LEAD_DETAILS } from './constants';

const useCallDisposition = (onSuccess?: () => void) => {
    const req = useRequest();
    const queryClient = useQueryClient();
    const setNotification = useSetNotification();

    const request = ({ payload }: { payload: CallDispositionPayload }) => {
        const { lead_id, ...body } = payload;
        return req({
            url: `${envVars.API_RTM_HOSTNAME}enterprise/leads/${lead_id}/call-disposition/`,
            method: 'POST',
            body: JSON.stringify(body)
        });
    };

    return useMutation({
        mutationFn: request,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [LEAD_DETAILS] });
            setNotification({ message: 'Call logged' });
            onSuccess && onSuccess();
        },
        onError: (error: { errors: string[] }) => {
            return error;
        }
    });
};

export default useCallDisposition;
